import { setPostLoginPath } from "../../auth/postLoginPath";
export var getPortalAppUrl = function () {
    var portalUrl = (process.env.PORTAL_URL || "http://localhost:7004").replace(/\/$/, "");
    return "".concat(portalUrl, "/app/participe");
};
export var goToOrLogin = function (_a) {
    var hasPortalConnect = _a.hasPortalConnect, hasToken = _a.hasToken, isAuthenticated = _a.isAuthenticated, login = _a.login, navigate = _a.navigate, path = _a.path;
    if (hasToken || isAuthenticated) {
        navigate(path);
        return;
    }
    setPostLoginPath(path);
    if (hasPortalConnect) {
        void login({
            prompt: "login",
            redirectUri: getPortalAppUrl(),
        });
        return;
    }
    if (typeof window !== "undefined" && window.parent !== window) {
        window.parent.postMessage(JSON.stringify({ type: "LOGIN", payload: undefined }), "*");
        return;
    }
    navigate("/login");
};
